import {BaseComparisonOperator} from '../base-comparison-operator';

export class EqualOperator extends BaseComparisonOperator {
  compare(value1: unknown, value2: unknown): boolean {
    if(this._isBooleanAsString(value1) || this._isBooleanAsString(value2)) {
      return value1?.toString() === value2?.toString();
    }
    // eslint-disable-next-line
    return value1 == value2;
  }

  private _isBooleanAsString(value: any) {
    if (value === 'true' || value === 'false') {
      return true;
    }

    return false;
  }
}
